<template>
  <v-container :class="containerClass" fluid>
    <subscription-order-form
      mode="add"
      :subscription-package-id="subscriptionPackageId"
      :student-id="studentId"
      @cancel="onCancel"
    >
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('subscription-orders.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Create new subscription order</h2>
        </div>
      </template>
    </subscription-order-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import SubscriptionOrderForm from '@components/SubscriptionOrder/Form'
export default {
  components: {
    SubscriptionOrderForm,
  },
  layout: LayoutDashboard,
  props: {
    subscriptionPackageId: {
      type: Number,
      default: null,
      required: false,
    },
    studentId: {
      type: Number,
      default: null,
      required: false,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('subscription-orders.index')
    },
  },
}
</script>
